import { render, staticRenderFns } from "./AigcImageGenerator.vue?vue&type=template&id=13cbd23c&scoped=true&"
import script from "./AigcImageGenerator.vue?vue&type=script&lang=js&"
export * from "./AigcImageGenerator.vue?vue&type=script&lang=js&"
import style0 from "./AigcImageGenerator.vue?vue&type=style&index=0&id=13cbd23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbd23c",
  null
  
)

export default component.exports